
import apiRequest from './apiRequest';

const bankApi = {
    async createBankDetails(accountId, bankData, token) {
        const url = `/api/accounts/${accountId}/bank-details`;
        return apiRequest(url, 'POST', token, bankData);
    },

    async getBankDetails(accountId, token) {
        const url = `/api/accounts/${accountId}/bank-details`;
        return apiRequest(url, 'GET', token);
    },

    async updateBankDetails(accountId, bankData, token) {
        const url = `/api/accounts/${accountId}/bank-details`;
        return apiRequest(url, 'PUT', token, bankData);
    },

    async deleteBankDetails(accountId, token) {
        const url = `/api/accounts/${accountId}/bank-details`;
        return apiRequest(url, 'DELETE', token);
    },
};

export default bankApi;
